export default "__VITE_ASSET__BH8vpm5p__"